import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, OnInit, Output } from '@angular/core';
import { NbMenuItem } from '@nebular/theme';
import { StringCleanUtils } from 'app/shared/string-clean.utils';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

import { AppConfigService } from '../app-config/app-config.service';
import { AbstractHttpService } from '../base/abstract.http.service';
import { CATEGORY } from '../base/service-const';

@Injectable({
  providedIn: 'root'
})
export class CategoryService extends AbstractHttpService<any> implements OnInit {

  baseCategories: any[] = [];

  building: boolean = false;
  
  @Output() buildedMenu = new EventEmitter();


  defaultCategory: NbMenuItem = {
    title: 'Todos',
    link: 'products/',
  };

  constructor(
    protected _httpClient: HttpClient,
    private appConfigService: AppConfigService
  ) { 
    super(_httpClient, CATEGORY, appConfigService.apiBaseUrl);
  }
  ngOnInit(): void {
    
  }

  findAll(): Observable<any> {
    this.building = true;
    return this.list().pipe(take(1));
  }

  buildMenu(categoriesList) {
    this.building = true
    this.baseCategories = categoriesList;
    
    let allCategories = this.baseCategories;

    // Ordena a lista, deixando as raizes primeiro
    allCategories.sort((n1, n2) => {
      if (n1.fatherCode < n2.fatherCode) return 1;
      if (n1.fatherCode > n2.fatherCode) return -1;
      return 0;
    });
    allCategories.forEach((element) => {
      if (!element.children)
        element.children = [];
    });
    for (let index = 0; index < allCategories.length; index++) {
      if (allCategories[index].fatherCode) {
        const childCategory = allCategories.shift();
        allCategories.map((element) => {
          if (element.id == childCategory.fatherCode) {
            element.children.push(childCategory);
          }
        });
        // diminui para passar novamente na posição anterior
        index--;
      } else {
        break;
      }
    }
    allCategories = this._buildComponent(allCategories);
    allCategories.unshift(this.defaultCategory);
    this.buildedMenu.emit(allCategories);
    return allCategories;
  
  }

  _buildComponent(result): Array<NbMenuItem> {
    const completeList = [];

    for (let index = 0; index < result.length; index++) {
      const element = result[index];
      let childrens = [];
      let endCategory = true;
      if (element.children.length > 0) {
        endCategory = false;
        childrens = this._buildComponent(element.children);
      }
      const newNode: NbMenuItem = {
        title: StringCleanUtils.titleize(element.name),
        // icon: (!endCategory ? 'arrow-right-outline' : ''),
        link: 'products',
        children: (!endCategory ? childrens : null),
        queryParams: { category: element.id},
      };

      // if (element.fatherCode != null || newNode.children?.length > 0)
        completeList.push(newNode);
    }

    completeList.sort((n1, n2) => {
      if (StringCleanUtils.replaceSpecialChars(n1.title) === StringCleanUtils.replaceSpecialChars(n2.title)) return 0;
      return (StringCleanUtils.replaceSpecialChars(n1.title) > StringCleanUtils.replaceSpecialChars(n2.title) ? 1 : -1);

    });
    return completeList;
  }
  
}
